export const ALLOWED_OBJECTIVE_REQUIREMENTS = ['GET_NFT'];